import type { Nullish } from '@iheartjane/types';

import { setCookie } from '@jane/bloom/utils/cookie.client';

export const PROMO_CODE_COOKIE_NAME = 'promo_code';
/**
 * Clears the promo code cookie from the client side.
 * Since the cookie is not httpOnly, it can be cleared directly.
 */
export function clearPromoCode(cookiePrefix: Nullish<string>) {
  const cookieName = `${cookiePrefix ?? ''}${PROMO_CODE_COOKIE_NAME}`;
  setCookie(cookieName, '', 0);
}
